import { apiGet, apiPatch, apiPost, apiPut } from './apiClient.js';

export const inventoryApi = {
  listProducts:   (params) => apiGet('/api/inventory/products', params),
  createProduct:  (body)   => apiPost('/api/inventory/products', body),
  updateProduct:  (id, body) => apiPut(`/api/inventory/products/${id}`, body),
  nextProductSku: (productType) => apiGet('/api/inventory/products/next-sku', { productType }),
  listCategories: ()       => apiGet('/api/inventory/categories'),
  listSuppliers:  ()       => apiGet('/api/inventory/suppliers'),
  createSupplier: (body)   => apiPost('/api/inventory/suppliers', body),
  listWarehouses: ()       => apiGet('/api/inventory/warehouses'),
  listBins:       (warehouseId) => apiGet(`/api/inventory/warehouses/${warehouseId}/bins`),
  createBin:      (body)   => apiPost('/api/inventory/bins', body),
  binContents:    (warehouseId) => apiGet(`/api/inventory/warehouses/${warehouseId}/bin-stock`),
  binPutaway:     (body)   => apiPost('/api/inventory/bin-stock/putaway', body),
  binPick:        (body)   => apiPost('/api/inventory/bin-stock/pick', body),
  binMove:        (body)   => apiPost('/api/inventory/bin-stock/move', body),
  stockByProduct: (productId) => apiGet(`/api/inventory/stock/by-product/${productId}`),

  lowStock:       ()       => apiGet('/api/inventory/stock/low'),
  listLots:       (params) => apiGet('/api/inventory/stock/lots', params),
  listExpiring:   (params) => apiGet('/api/inventory/stock/expiring', params),
  movements:      (params) => apiGet('/api/inventory/stock/movements', params),
  receiveStock:   (body)   => apiPost('/api/inventory/stock/receive', body),
  issueStock:     (body)   => apiPost('/api/inventory/stock/issue', body),
  transferStock:  (body)   => apiPost('/api/inventory/stock/transfer', body),
  adjustStock:    (body)   => apiPost('/api/inventory/stock/adjust', body),

  listCycleCounts:  (params) => apiGet('/api/inventory/cycle-counts', params),
  getCycleCount:    (id)     => apiGet(`/api/inventory/cycle-counts/${id}`),
  createCycleCount: (body)   => apiPost('/api/inventory/cycle-counts', body),
  postCycleCount:   (id)     => apiPatch(`/api/inventory/cycle-counts/${id}/post`),

  listReservations:   (params) => apiGet('/api/inventory/reservations', params),
  reserveStock:       (body)   => apiPost('/api/inventory/reservations', body),
  releaseReservation: (id)     => apiPatch(`/api/inventory/reservations/${id}/release`),

  listInspectionLots: (params) => apiGet('/api/inventory/inspection-lots', params),
  getInspectionLot:   (id)     => apiGet(`/api/inventory/inspection-lots/${id}`),
  createInspectionLot:(body)   => apiPost('/api/inventory/inspection-lots', body),
  addLotCharacteristic:(id, body) => apiPost(`/api/inventory/inspection-lots/${id}/characteristics`, body),
  acceptLot:          (id)     => apiPatch(`/api/inventory/inspection-lots/${id}/accept`),
  rejectLot:          (id, note) => apiPatch(`/api/inventory/inspection-lots/${id}/reject`, note ? { note } : {}),

  listConsignment:    (params) => apiGet('/api/inventory/consignment', params),
  getConsignment:     (id)     => apiGet(`/api/inventory/consignment/${id}`),
  receiveConsignment: (body)   => apiPost('/api/inventory/consignment/receive', body),
  withdrawConsignment:(body)   => apiPost('/api/inventory/consignment/withdraw', body),

  listContracts:      (params) => apiGet('/api/inventory/contracts', params),
  getContract:        (id)     => apiGet(`/api/inventory/contracts/${id}`),
  createContract:     (body)   => apiPost('/api/inventory/contracts', body),
  releaseContract:    (id, body) => apiPost(`/api/inventory/contracts/${id}/release`, body),
  closeContract:      (id)     => apiPatch(`/api/inventory/contracts/${id}/close`),

  atp:                (params) => apiGet('/api/inventory/stock/atp', params),

  listSchedulingAgreements: (params) => apiGet('/api/inventory/scheduling-agreements', params),
  getSchedulingAgreement:   (id)     => apiGet(`/api/inventory/scheduling-agreements/${id}`),
  createSchedulingAgreement:(body)   => apiPost('/api/inventory/scheduling-agreements', body),
  addScheduleLine:          (id, body) => apiPost(`/api/inventory/scheduling-agreements/${id}/lines`, body),
  closeSchedulingAgreement: (id)     => apiPatch(`/api/inventory/scheduling-agreements/${id}/close`),
  receiveScheduleLine:      (lineId, body) => apiPost(`/api/inventory/schedule-lines/${lineId}/receive`, body),

  listSerials:  (params) => apiGet('/api/inventory/serials', params),
  getSerial:    (id)     => apiGet(`/api/inventory/serials/${id}`),
  issueSerial:  (body)   => apiPost('/api/inventory/serials/issue', body),

  listSupplierEvaluations: (params) => apiGet('/api/inventory/supplier-evaluations', params),
  createSupplierEvaluation:(body)   => apiPost('/api/inventory/supplier-evaluations', body),
  supplierRanking:         ()       => apiGet('/api/inventory/reports/supplier-ranking'),

  listProductUnits: (productId)        => apiGet(`/api/inventory/products/${productId}/units`),
  addProductUnit:   (productId, body)  => apiPost(`/api/inventory/products/${productId}/units`, body),
  convertUom:       (productId, params) => apiGet(`/api/inventory/products/${productId}/convert`, params),

  listBackorders:   (params) => apiGet('/api/inventory/backorders', params),
  fulfillBackorder: (id)     => apiPost(`/api/inventory/backorders/${id}/fulfill`, {}),

  listMrpRuns:  ()       => apiGet('/api/inventory/mrp-runs'),
  getMrpRun:    (id)     => apiGet(`/api/inventory/mrp-runs/${id}`),
  runMrp:       ()       => apiPost('/api/inventory/mrp-runs', {}),
  convertMrp:   (id, body) => apiPost(`/api/inventory/mrp-runs/${id}/convert`, body),

  listRequisitions:   (params) => apiGet('/api/inventory/requisitions', params),
  getRequisition:     (id)     => apiGet(`/api/inventory/requisitions/${id}`),
  createRequisition:  (body)   => apiPost('/api/inventory/requisitions', body),
  autoReorder:        ()       => apiPost('/api/inventory/requisitions/auto-reorder'),
  submitRequisition:  (id)     => apiPatch(`/api/inventory/requisitions/${id}/submit`),
  approveRequisition: (id)     => apiPatch(`/api/inventory/requisitions/${id}/approve`),
  rejectRequisition:  (id, note) => apiPatch(`/api/inventory/requisitions/${id}/reject`, note ? { note } : {}),
  convertRequisition: (id, body) => apiPost(`/api/inventory/requisitions/${id}/convert`, body),

  listPurchaseOrders: (params) => apiGet('/api/inventory/purchase-orders', params),
  getPurchaseOrder:   (id) => apiGet(`/api/inventory/purchase-orders/${id}`),
  createPurchaseOrder:(body) => apiPost('/api/inventory/purchase-orders', body),
  confirmPO:         (id)  => apiPatch(`/api/inventory/purchase-orders/${id}/confirm`),
  approvePO:         (id)  => apiPatch(`/api/inventory/purchase-orders/${id}/approve`),
  rejectPO:          (id, note) => apiPatch(`/api/inventory/purchase-orders/${id}/reject`, note ? { note } : {}),
  receivePO:         (id, b) => apiPatch(`/api/inventory/purchase-orders/${id}/receive`, b),
  cancelPO:          (id)  => apiPatch(`/api/inventory/purchase-orders/${id}/cancel`),

  // Analytics (charts)
  stockValueByCategory: ()       => apiGet('/api/inventory/reports/stock-value-by-category'),
  poStatus:             ()       => apiGet('/api/inventory/reports/po-status'),
  movementsTrend:       (params) => apiGet('/api/inventory/reports/movements-trend', params),
  topProducts:          (params) => apiGet('/api/inventory/reports/top-products', params),

  // Insight strips (list-page summaries)
  poInsights:           ()       => apiGet('/api/inventory/reports/po-insights'),
};
